import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';

class Certificated {

}

@Injectable({
  providedIn: 'root'
})
export class CertificatedService {
  httpHeader = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };
  fc: string;

  constructor(private http: HttpClient) {

    console.log('URL---->', environment.baseUrl);
  }

  getCertificated(fc, type, subscriptionId): Observable<Certificated[]> {
    let url = environment.baseUrl;

    if (type === 'rpps') {
      url = environment.baseUrlRpps;
    } else if (type === 'co') {
      url = environment.baseUrlCo;
    }

    return this.http.get<Certificated[]>(url + '/users/certificated/verify/' + fc + '/' + subscriptionId)
        .pipe((x: Observable<Certificated[]>) => {
          console.log(x);
          return this.http.get<Certificated[]>(url + '/users/certificated/verify/' + fc + '/' + subscriptionId);
        });
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.error(error);
      console.log(`${operation} failed: ${error.message}`);
      return of(result as T);
    };
  }
}
